const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  filterStatus: "all",
};

const filterSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {
    filterSelected: (state, action) => {
      state.filterStatus = action.payload;
    },
  },
});

export default filterSlice.reducer;
export const { filterSelected } = filterSlice.actions;
